import { AiOutlineInfoCircle } from "react-icons/ai";
import { ErrorBox } from "./common/ErrorBox";
import { useFormContext } from "react-hook-form";

export const YesNoPicker = ({
  name,
  label,
  title,
  detailed_label,
  validation,
  errors,
}) => {
  const { register } = useFormContext();

  return (
    <div className="bg-white/60 rounded-2xl shadow-sm border border-gray-200/60 p-3.5 transition-all duration-200 hover:bg-white/80 hover:shadow-md backdrop-blur-sm">
      <div className="flex justify-between items-start mb-2">
        <h2 className="text-base font-semibold text-gray-900">{title}</h2>
        <AiOutlineInfoCircle className="text-gray-600 text-base cursor-pointer hover:text-gray-800 transition-colors flex-shrink-0" />
      </div>

      <div className="flex items-center gap-2.5 mt-2">
        <input
          type="checkbox"
          {...register(name, validation)}
          id="opmeting"
          className="w-5 h-5 border-2 border-gray-300 rounded-lg bg-white focus:ring-2 focus:ring-gray-400 focus:ring-offset-2 text-gray-900 hover:border-gray-400 transition-all duration-200 cursor-pointer"
          style={{ accentColor: '#1f2937' }}
        />
        <label
          htmlFor="opmeting"
          className="text-sm text-gray-700 font-medium cursor-pointer hover:text-gray-900 transition-colors"
        >
          {detailed_label}
        </label>
      </div>
    </div>
  );
};
